module.exports = __webpack_public_path__ + "static/eolian-mobile-34b9b9aec70c03d805633f542e59a98e.svg";